import React, { useEffect, useState } from 'react';
import { StyledBox, StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import Card from '../Common/Card';
import { useTranslation } from 'react-i18next';
import DetailsRow from '../Common/DetailsRow';
import { useTheme } from 'styled-components';
import Icon from '../Common/Icon';
import { StyledDiscountContent, StyledDiscountIcon } from './style';
import { fixLocaleString } from '../../Utils/common.util';
import FactureDetailsTable from './FactureDetailsTable';
import { getFactureData } from '../../Services/facture.service';
import { useParams } from 'react-router';
import LoadingBox from '../Common/LoadingBox';
import useLandingStore from '../../Store/Landing';

const Facture: React.FC = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const { factureId } = useParams();

  const landingData = useLandingStore((state) => state.landingData);

  const [factureData, setFactureData] = useState(null);
  const [loading, setLoading] = useState(false);
  const getData = async (factureId: string): Promise<void> => {
    setLoading(true);

    const response = await getFactureData(factureId);
    setFactureData(response);
    setLoading(false);
  };

  useEffect(() => {
    getData(factureId);
  }, []);

  return (
    <LoadingBox loading={loading}>
      <StyledDiv pt={9} px={8} pb={18}>
        <Card>
          <DetailsRow
            mb={8}
            px={5}
            title={
              <StyledSpan fontSize={4} color="normalText">
                {t('facture.factureNumber')}
              </StyledSpan>
            }
            value={
              <StyledSpan
                color="primaryBlue"
                letterSpacing="0.3rem"
                fontSize={2}>
                {factureData?.facture.factureOrginalId || '-'}
              </StyledSpan>
            }
            lineColor={theme.colors.border}
          />
          <StyledDiv display="flex" gap={12} width="100%" mb={9}>
            <StyledBox
              flex={1}
              display="flex"
              justifyContent="center"
              color="secondaryText"
              letterSpacing="0.3rem">
              <StyledSpan>
                <Icon name="clock" mr={7} fontSize={6} color="primaryBlue" />
                {new Date(
                  factureData?.facture.facturE_TIMEDATE_DT
                ).toLocaleString('fa-IR', {
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </StyledSpan>
            </StyledBox>
            <StyledBox
              flex={3}
              color="secondaryText"
              justifyContent="flex-end"
              letterSpacing="0.3rem">
              {new Date(
                factureData?.facture.facturE_TIMEDATE_DT
              ).toLocaleString('fa-IR', {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric',
                calendar: 'persian'
              })}
              <Icon
                name="calendar_month"
                mr={7}
                fontSize={6}
                color="primaryBlue"
              />
            </StyledBox>
          </StyledDiv>
          {(!!factureData?.facture?.facturE_DAMPING_PRICE_IN ||
            !!factureData?.creditValue) && (
            <StyledBox mb={6}>
              <StyledDiscountIcon>
                <Icon
                  name="discount"
                  fontSize={20}
                  color="primaryPurple"
                  lineHeight="48px"
                  mt={2}
                />
              </StyledDiscountIcon>
              <StyledDiscountContent>
                {!!factureData?.facture?.facturE_DAMPING_PRICE_IN && (
                  <DetailsRow
                    title={`${t('facture.discount')}:`}
                    value={
                      <StyledDiv color="secondaryGreen" fontSize={2}>
                        {fixLocaleString(
                          factureData?.facture.facturE_DAMPING_PRICE_IN
                        ) || '-'}
                        <StyledSpan mr={3} color="minorText" fontSize="0.8rem">
                          {!!factureData?.facture.facturE_DAMPING_PRICE_IN &&
                            landingData.currency}
                        </StyledSpan>
                      </StyledDiv>
                    }
                  />
                )}
                {!!factureData?.creditValue && (
                  <DetailsRow
                    title={`${t('facture.credit')}:`}
                    value={
                      <StyledDiv color="secondaryText" fontSize={2}>
                        {factureData?.creditValue}
                        <StyledSpan mr={3} color="minorText" fontSize="0.8rem">
                          {!!factureData?.creditValue && landingData.currency}
                        </StyledSpan>
                      </StyledDiv>
                    }
                  />
                )}
              </StyledDiscountContent>
            </StyledBox>
          )}
          {(factureData?.facture.cachierName ||
            factureData?.facture.deliveryName) && (
            <StyledBox flexDirection="column" mb="16px !important">
              {factureData?.facture.cachierName && (
                <DetailsRow
                  color="normalText"
                  fontSize={2}
                  title={`${t('facture.cashier')}:`}
                  value={
                    <StyledSpan>
                      {factureData?.facture.cachierName || '-'}
                    </StyledSpan>
                  }
                  mb={5}
                />
              )}
              {factureData?.facture.deliveryName && (
                <DetailsRow
                  color="normalText"
                  fontSize={2}
                  title={`${t('facture.delivery')}:`}
                  value={
                    <StyledSpan>
                      {factureData?.facture.deliveryName || '-'}
                    </StyledSpan>
                  }
                />
              )}
            </StyledBox>
          )}
          <FactureDetailsTable
            tableData={factureData?.facureContainer}
            finalPrice={factureData?.facture.finanlPrice}
          />
        </Card>
      </StyledDiv>
    </LoadingBox>
  );
};

export default Facture;
